/* eslint camelcase: 0 */
import { MonitaroGatewayBase } from './base'
import { toIndustryProps } from './translator/industry'
import { toQuery, toQueryProps } from './translator/query'
import { EmptyResponsePropsFactory } from '@/entities/Response'
import { IQueryProps } from '@/entities/Query'
import { FetchIndustry, GetIndustry } from '@/infrastructure/network/Monitaro/requests/industry'

export default class Industry extends MonitaroGatewayBase {
  async FetchIndustry(query?: IQueryProps) {
    const response = await this.apiClient.request(new FetchIndustry(toQuery(query)))
    return EmptyResponsePropsFactory({
      items: response.industries.map((prop) => toIndustryProps(prop)),
      query: toQueryProps(response.query)
    })
  }

  async GetIndustry(id: string) {
    const { industry } = await this.apiClient.request(new GetIndustry(id))
    return toIndustryProps(industry)
  }
}
